<div class="container-fluid">
    <div class="pb-wrapper">
        <div class="tab-content" *ngIf="showPropertyFlag">

            <ng-container [ngSwitch]="propertyView">
                <rsb-post-location *ngSwitchCase="1" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></rsb-post-location>
                <rsb-post-details *ngSwitchCase="2" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></rsb-post-details>
                <rsb-post-features *ngSwitchCase="3" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></rsb-post-features>
                <rsb-post-gallery *ngSwitchCase="4" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></rsb-post-gallery>
                    <app-post-upload-video *ngSwitchCase="10" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></app-post-upload-video>
                <app-floorplan *ngSwitchCase="5" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></app-floorplan>
                <app-propertyhighlights *ngSwitchCase="6" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></app-propertyhighlights>
                <app-propertylocation *ngSwitchCase="7" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></app-propertylocation>
                <app-specifications *ngSwitchCase="8" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></app-specifications>
                <rsb-post-publish *ngSwitchCase="9" (formChange)="changeFormStatus($event)"
                    (showNextPage)="openPage($event)"></rsb-post-publish>
            </ng-container>
        </div>
    </div>
</div>